/**
 * Create Support Ticket context for custom hook
 */

import { createContext } from 'react'

const SupportTicketContext = createContext({
  createSupportTicket: () => {}
})

export default SupportTicketContext
